<template>
  <div v-show="loader.show" id="loader" class="loader z-index-999">
    <v-dialog :value="loader.show" hide-overlay persistent min-width="310" max-width="500" class="z-index-999">
      <v-card color="primary" class="not-full-width-modal">
        <v-card-text class="loader__text text-truncate">
          {{ loader.message }}
          <v-progress-linear indeterminate color="white" class="mt-2" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import store from '@/store';

const loader = computed(() => store.getters.loader);
const theme = computed(() => store.getters.theme);
</script>

<style scoped lang="scss">
.loader {
  width: 100vw;
  height: 100vh;
  position: fixed;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.59);

  :deep(.v-card) {
    padding: 12px !important;
    border-radius: 8px !important;
  }

  &__text {
    color: var(--color-white) !important;
  }
}

.z-index-999 {
  z-index: 999 !important;
}
</style>
